"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Export data
var _default = exports.default = {
  domain: '',
  learnMore: {
    logo: {
      alt: 'SAP Logo',
      src: '/sites/all/modules/custom_concur/concur_sap_banner/images/sap-logo.png'
    },
    text: 'Désormais Concur fait partie de SAP.',
    learn: {
      href: '/sap',
      text: ' En savoir plus'
    }
  },
  social: [{
    network: 'twitter',
    href: ''
  }, {
    network: 'linkedin',
    href: ''
  }],
  support: {
    links: [{
      text: 'BLOG',
      href: '/newsroom'
    }, {
      text: 'NOUS CONTACTER',
      href: '/contact'
    }, {
      text: 'MENTIONS LEGALES',
      href: '/mentions-legales'
    }, {
      text: 'SUPPORT',
      href: '/support'
    }],
    selector: 'SÉLECTEUR DE PAYS',
    modelTitle: 'Select your location:'
  },
  copyright: {
    text: '© Copyright @{year} Concur Technologies, Inc. All rights reserved.',
    links: [{
      text: 'Politique de confidentialité',
      href: '/politique-confidentialite'
    }, {
      text: "Conditions d'utilisation",
      href: ''
    }]
  }
};